/* eslint-disable no-case-declarations */
import { combineReducers } from "redux";
import userReducer, { UserState } from "./tenantUser/reducer";

export interface Entity {
    id: string;
}

export interface Filter {
    offset?: number;
    limit?: number;
}

export interface EntityState<T = Entity> {
    items: {
        results: T[];
        count: number;
    }
    isLoading: boolean;
    filter: Filter;
    localFiltering: boolean;
    reload: boolean;
}

export interface EmailRecipient { displayName: string, address: string }

export interface EmailRecipients {
    to: EmailRecipient[];
    cc: EmailRecipient[];
    bcc: EmailRecipient[];
}

export interface AdminState {
    user: UserState;
}

export const defaultFilter: Filter = { offset: 0, limit: 25 };


export default combineReducers({
    user: userReducer,
});
